/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import { BrowserRouter as Router, Redirect, Switch } from "react-router-dom";
import ErrorBoundary from "../common/components/ErrorBoundary";
import PublicRouter from "../common/routes/PublicRouter";
import MainRoutes from "./RouteViews";
import GlobalHistory from "../common/utils/GlobalHistory";
import "../common/css/styles.css";

const App = () => (
  <>
    <ErrorBoundary>
      <Router>
        <GlobalHistory />
        <Switch>
          <PublicRouter exact path="/" component={() => <Redirect to="/customers" />} />
          <PublicRouter path="/:baseRoute" component={MainRoutes} />
        </Switch>
      </Router>
    </ErrorBoundary>
  </>
);
export default App;
